import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shootsight-comp',
  templateUrl: './shootsight-comp.component.html',
  styleUrls: ['./shootsight-comp.component.scss']
})
export class ShootsightCompComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
